import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from '../../../..//global/services/client.service';
import { ToastersService } from '../../../..//global/services/toasters.service';
import { Client } from '../../../..//global/types/Client';
import { SimpleModalComponent } from '../../popups/confirmation-modal/simple-modal.component';

@Component({
  selector: 'app-clients-tab',
  templateUrl: './clients-tab.component.html',
  styleUrls: ['../shared-templates.component.less'],
})
export class ClientsTabComponent {
  @Input() clients: Client[];
  @Output() editClient: EventEmitter<Client> = new EventEmitter<Client>();

  isLoading = false;
  openDots = false;
  clientId: string;

  constructor(
    private clientService: ClientService,
    private toasterService: ToastersService,
    private modalService: NgbModal,
  ) {}

  onEditClient(client: Client) {
    this.editClient.emit(client);
    this.openDots = false;
  }

  async deleteSelectedClient(client: Client) {
    const modal = this.modalService.open(SimpleModalComponent, {
      centered: true,
      backdropClass: 'popup-background',
      windowClass: 'popup-box',
    });
    modal.componentInstance.width = 24;
    modal.componentInstance.hasCancellationButton = true;
    modal.componentInstance.message = `Are you sure you want to delete client ${client.name}?`;
    if (!(await modal.result)) return;
    this.isLoading = true;
    try {
      await this.clientService.deleteClient(client.id);
      this.toasterService.createNewToast({ type: 'Success', title: 'Client successfully deleted!' });
    } catch (error) {
      this.toasterService.createErrorToast(error.message);
    }
    this.isLoading = false;
  }

  showPopupDots(clientId: string) {
    this.openDots = !this.openDots;
    this.clientId = clientId;
  }
}
